import React, { useEffect, useState, useRef } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { useProjectFilter, AVAILABLE_PROJECTS } from '../contexts/ProjectFilterContext';
import { motion, AnimatePresence } from 'framer-motion';
export function ProjectSelector() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const {
    selectedProjects,
    isProjectSelected,
    toggleProject,
    setSelectedProjects
  } = useProjectFilter();
  const allSelected = selectedProjects.length === AVAILABLE_PROJECTS.length;
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen]);
  const getDisplayText = () => {
    if (selectedProjects.length === 0) {
      return 'No Sites';
    }
    if (allSelected) {
      return 'All Sites';
    }
    if (selectedProjects.length === 1) {
      return selectedProjects[0];
    }
    return `${selectedProjects.length} Sites`;
  };
  const handleSelectAll = () => {
    if (allSelected) {
      setSelectedProjects([]);
    } else {
      setSelectedProjects(AVAILABLE_PROJECTS);
    }
  };
  return <div className="relative" ref={dropdownRef} data-id="element-3007" data-mp="2uuhph8v3q19k">
      <button onClick={() => setIsOpen(!isOpen)} className="bg-white text-black text-sm px-3 py-1.5 pr-8 rounded w-48 focus:outline-none focus:ring-2 focus:ring-emerald-500 text-left flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-3008" data-mp="2zlpwjy8ylajk">
        <span className="truncate" data-id="element-3009" data-mp="2pu27u53se7ls">{getDisplayText()}</span>
        <ChevronDown size={14} className={`absolute right-2 text-gray-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-3010" data-mp="2bxoth4ujumbj" />
      </button>

      <AnimatePresence data-id="element-3011" data-mp="mfry964ypm2m">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} transition={{
        duration: 0.15
      }} className="absolute top-full mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50 right-0" data-id="element-3012" data-mp="mgkv9fe4cx7k">
            {/* Select All option */}
            <button onClick={handleSelectAll} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 transition-colors flex items-center justify-between border-b border-gray-100 mb-1 pb-3" data-id="element-3013" data-mp="10d85ukyzvlvy">
              <span className="font-medium text-gray-900" data-id="element-3014" data-mp="3g6fgbz8a5bcu">
                {allSelected ? 'Deselect All' : 'Select All'}
              </span>
              {allSelected && <div className="w-4 h-4 bg-emerald-500 rounded flex items-center justify-center" data-id="element-3015" data-mp="1rmt5zwo9is0u">
                  <Check size={12} className="text-white" data-id="element-3016" data-mp="1vnv8cmdh7k71" />
                </div>}
            </button>

            {/* Individual projects */}
            {AVAILABLE_PROJECTS.map(project => {
          const isSelected = isProjectSelected(project);
          return <button key={project} onClick={() => toggleProject(project)} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 transition-colors flex items-center justify-between" data-id="element-3017" data-mp="2ad14g1h0ouap">
                  <span className={isSelected ? 'text-gray-900' : 'text-gray-600'} data-id="element-3018" data-mp="2jeig97ne69tl">
                    {project}
                  </span>
                  {isSelected && <div className="w-4 h-4 bg-emerald-500 rounded flex items-center justify-center" data-id="element-3019" data-mp="p22f2l9gdlvl">
                      <Check size={12} className="text-white" data-id="element-3020" data-mp="u0m10lo1qxny" />
                    </div>}
                </button>;
        })}

            {/* Footer info */}
            <div className="px-4 py-2 text-xs text-gray-500 border-t border-gray-100 mt-1 pt-3" data-id="element-3021" data-mp="3px06trh35tec">
              {selectedProjects.length} of {AVAILABLE_PROJECTS.length} selected
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}